"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Failure = exports.Success = exports.Try = exports.wrapPromise = exports.call = void 0;
const helpers_1 = require("./helpers");
const maybemonad_1 = require("./maybemonad");
function call(f) {
    try {
        const result = f();
        return Try.fromValue(result);
    }
    catch (ex) {
        return Try.fromError(ex);
    }
}
exports.call = call;
function wrapPromise(p) {
    return p().then(s => new Success(s)).catch(e => new Failure(e));
}
exports.wrapPromise = wrapPromise;
class Try {
    static chain(monad) {
        return (0, helpers_1.chain)(monad);
    }
    static flatten(coll) {
        return (0, helpers_1.flatten)(coll, Try.empty);
    }
    static fromError(error) {
        return new Failure(error);
    }
    static fromValue(value) {
        return new Success(value);
    }
}
exports.Try = Try;
Try.empty = () => new Failure(new Error());
class Success {
    constructor(_value) {
        this._value = _value;
        this.forEach = (f) => f(this._value);
        this.unsafeLift = () => this._value;
        this.toMaybe = () => (0, maybemonad_1.maybe)(this._value);
        this.empty = () => Try.empty();
    }
    onSuccess(f) { f(this._value); return this; }
    onFailure(_) { return this; }
    reduce(f, start) { return f(start, this._value); }
    get succeeded() { return true; }
    get result() { return this._value; }
    get error() { throw new Error("No error occurred"); }
    map(f) {
        return call(() => f(this._value));
    }
    flatMap(f) {
        return f(this._value);
    }
    unit(x) {
        return call(() => x);
    }
    get hasValue() {
        return true;
    }
    equals(that) {
        return (0, helpers_1.anyEquals)(this, that);
    }
    toPromise() { return Promise.resolve(this._value); }
    isEmpty() { return false; }
}
exports.Success = Success;
class Failure {
    constructor(_error) {
        this._error = _error;
        this.toMaybe = () => new maybemonad_1.Nothing();
        this.empty = () => Try.empty();
    }
    onSuccess(_f) { return this; }
    onFailure(f) { f(this._error); return this; }
    reduce(_, start) { return start; }
    get succeeded() { return false; }
    get result() { throw new Error("Try resulted in an error!"); }
    get error() { return this._error; }
    map(_f) {
        return this;
    }
    flatMap(_f) {
        return this;
    }
    unit(x) {
        return call(() => x);
    }
    forEach(_f) { return; }
    unsafeLift() {
        throw new Error("Is a failure");
    }
    get hasValue() {
        return false;
    }
    equals(that) {
        return (0, helpers_1.anyEquals)(this, that);
    }
    toPromise() { return Promise.reject(this._error); }
    isEmpty() { return true; }
}
exports.Failure = Failure;
//# sourceMappingURL=trymonad.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/tsmonads/lib/src/trymonad.js
// module id = 1226
// module chunks = 0